import React from 'react';
import ApprovalLineTemplateContainer from '../../containers/approvalmng/ApprovalLineTemplateContainer';

const ApprovalLineTemplatePage = () => {
  return <ApprovalLineTemplateContainer />;
};

export default ApprovalLineTemplatePage;
